import React from "react";
import styles from "./EditAdminPage.module.css";
import {useSpring, animated} from "react-spring";
import UploadVideo from "./UploadVideo";
import {Box, makeStyles, Tab, Tabs, TabsProps, Theme} from "@material-ui/core";
import EditRecommend from "./EditRecommend";
import EditProgram from "./EditProgram";
import EditUser from "./EditUser";
import OnLeaveDialog from "../../common/components/dialog/OnLeaveDialog";
// import EditProjectIndex from "../../pages/admin/EditProject/EditProjectIndex";
// import EditContextPhraseIndex from "../../pages/admin/EditContextPhrase/EditContextPhraseIndex";
import ConfirmProcessStatusIndex from "../../pages/admin/ConfirmProcessStatus/ConfirmProcessStatusIndex";
import ExportSurvey from "./ExportSurvey";
import StatisticsManagementIndex from "../../pages/admin/StatisticsManagement/StatisticsManagementIndex";
import {useSelector} from "react-redux";
import {AppState} from "src/root/RootReducer";
import {isAdmin, isPresenter} from "src/utils/LogicUtils";

interface EditAdminPageProps {
    /* モーダル表示切り替え */
    in: boolean;
    onEnter?: () => void;
    onExited?: () => void;
    // モーダル閉じる
    onClose?: () => void;
    isSaved: boolean;
    setIsSaved: (flg: boolean) => void;
    children?: React.ReactElement;
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}

function TabPanel(props: TabPanelProps) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: any) {
    return {
        id: `vertical-tab-${index}`,
        "aria-controls": `vertical-tabpanel-${index}`
    };
}

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        // flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        display: "flex",
        position: "relative"
        // height: "100%"
    },
    tabs: {
        borderRight: `1px solid ${theme.palette.divider}`
    }
}));

const EditAdminPage = React.forwardRef<HTMLDivElement, EditAdminPageProps>(function EditAdminPage(
    props,
    ref
) {
    const {in: open, children, onEnter, onExited, onClose, isSaved, setIsSaved, ...other} = props;

    const style = useSpring({
        from: {opacity: 0},
        to: {opacity: open ? 1 : 0},
        onStart: () => {
            if (open && onEnter) {
                onEnter();
            }
        },
        onRest: () => {
            if (!open && onExited) {
                onExited();
            }
        }
    });

    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [newValue, setNewValue] = React.useState(0);
    const [openDialog, setOpenDialog] = React.useState(false);

    const handleChange = (event, newValue) => {
        if (isSaved) {
            setValue(newValue);
        } else {
            setOpenDialog(true);
            setNewValue(newValue);
        }
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleCancel = () => {
        handleCloseDialog();
        setNewValue(0);
    };

    const handleConfirm = () => {
        setValue(newValue);
        setIsSaved(true);
        handleCloseDialog();
    };

    const {userInfo} = useSelector((state: AppState) => ({
        userInfo: state.user.userInfo
    }));





    const tabItems =isAdmin(userInfo?.roles) ?  [
        {label: "Video管理", component: <UploadVideo setIsSaved={setIsSaved} isSaved={isSaved}/>},
        {label: "おすすめ管理", component: <EditRecommend setIsSaved={setIsSaved} isSaved={isSaved}/>},
        {label: "Channel管理", component: <EditProgram setIsSaved={setIsSaved} isSaved={isSaved}/>},
        // { label: "Project管理", component: <EditProjectIndex isSaved={isSaved} setIsSaved={setIsSaved} /> },
        {label: "User管理", component: <EditUser setIsSaved={setIsSaved} isSaved={isSaved}/>},
        // { label: "辞書管理", component: <EditContextPhraseIndex setIsSaved={setIsSaved} isSaved={isSaved} /> },
        {label: "進捗管理", component: <ConfirmProcessStatusIndex/>},
        {label: "アンケート管理", component: <ExportSurvey/>},
        {label: "統計管理", component: <StatisticsManagementIndex/>}
    ] : isPresenter(userInfo?.roles) ? [
        {label: "Video管理", component: <UploadVideo setIsSaved={setIsSaved} isSaved={isSaved}/>},
        {label: "進捗管理", component: <ConfirmProcessStatusIndex/>}
    ] : [];

    return (
        <>
            <animated.div ref={ref} style={style} {...other}>
                <div className={classes.root}>
                    <Tabs
                        orientation="vertical"
                        variant="scrollable"
                        value={value}
                        onChange={handleChange}
                        aria-label="Admin tabs"
                        className={styles.tabs}
                        style={{width: "200px", color: "var(--red)"}}
                        textColor="secondary"
                    >
                        {tabItems.map((item, index) => (
                            <Tab
                                key={index}
                                label={item.label}
                                {...a11yProps(index)}
                                style={{textTransform: "none"}}
                            />
                        ))}
                    </Tabs>
                    {tabItems.map((item, index) => (
                        <TabPanel key={index} value={value} index={index}>
                            <div className={styles.tabItem}>{item.component}</div>
                        </TabPanel>
                    ))}
                </div>
            </animated.div>
            <OnLeaveDialog
                openDialog={openDialog}
                handleCloseDialog={handleCloseDialog}
                handleCancel={handleCancel}
                handleConfirm={handleConfirm}
            />
        </>
    );
});

export default EditAdminPage;
